import React,{useState,useEffect} from 'react'

function ProductDetails({ product, selectedProduct, setSelectedProduct, getProductSku }) {
    // const isSelected =  getProductSku.sku === product.sku ? getProductSku : selectedProduct === product.sku;
    const isSelected = selectedProduct === product.sku;
  
    console.log(isSelected, selectedProduct, product.sku,"all---hbkj");


    // console.log(getProductSku,"sku-details----")

    function handleSelect() {
        setSelectedProduct(isSelected ? null : product.sku);

        // setSelectedProduct(product.sku);
        // console.log("hello")
    }


    // const isSelected = getProductSku.sku === product.sku || selectedProduct === product.sku;

    // console.log(isSelected,"selected-all")
    console.log(selectedProduct,"selected")

    return (
        <div
            className={`img-wrapper-container ${isSelected ? 'select-product' : ''}`}
            onClick={handleSelect}
        >
            <div className='carousel-item'>
                <img src={product.image} className={`product-img ${isSelected ? 'select-img' : ''}`} alt={`Product ${product.sku}`} />
            </div>
            <p className='product-name'>{product.name}</p>
        </div>
    );
}

export default ProductDetails;